<template
  ><b-table-simple
    v-if="sectionTable"
    class="tsny_text-mid text-center"
    thead-tr-class="tsny_table-head"
    tbody-tr-class="tsny_table-body"
  >
    <b-thead
      ><b-tr>
        <b-th>Raw Score</b-th>
        <b-th v-for="(count, section) in questionsPerSection" :key="section">
          {{ section }}
        </b-th>
      </b-tr> </b-thead
    ><b-tbody>
      <b-tr>
        <b-td>0</b-td>
        <b-td v-for="(count, section) in questionsPerSection" :key="section">
          <b-input
            class="tsny_input text-center"
            type="number"
            min="0"
            v-model="sectionTable[section][0]"
          />
        </b-td>
      </b-tr>
      <b-tr v-for="i in highestRawScore" :key="i">
        <b-td>{{ i }}</b-td>
        <b-td v-for="(count, section) in questionsPerSection" :key="section">
          <b-input
            class="tsny_input text-center"
            v-if="i <= count"
            type="number"
            min="0"
            v-model="sectionTable[section][i]"
          />
        </b-td> </b-tr
    ></b-tbody> </b-table-simple
></template>

<script>
import { _ } from "vue-underscore";

export default {
  name: "SectionScoreTable",
  props: {
    courseId: {
      type: String,
      default: null
    },
    exam: {
      type: Object,
      default: null
    },
    scoreTable: {
      type: Object,
      default: null
    }
  },
  computed: {
    questionsPerSection() {
      let questionsPerSection = {
        Math: 0
      };
      this.exam.sections.forEach(section => {
        let length = section.questions.length;

        this.courseId === "SAT"
          ? section.section === "Math"
            ? (questionsPerSection.Math += length)
            : (questionsPerSection[section.subsection] = length)
          : (questionsPerSection[section.section] = length);
      });
      return questionsPerSection;
    },
    highestRawScore() {
      return _.chain(this.questionsPerSection)
        .values()
        .max()
        .value();
    }
  },
  data: () => ({
    sectionTable: null
  }),
  mounted() {
    if (this.scoreTable.sectionTable) {
      this.sectionTable = this.scoreTable.sectionTable;
    } else {
      this.sectionTable = this.generateSectionTable();
      this.scoreTable.sectionTable = this.sectionTable;
    }
  },
  methods: {
    generateSectionTable() {
      let sectionTable = {};
      _.chain(this.questionsPerSection)
        .keys()
        .each(key => (sectionTable[key] = {}));
      return sectionTable;
    }
  }
};
</script>

<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}
</style>
